import { render, staticRenderFns } from "./MyCheckbox.vue?vue&type=template&id=3c5d1c48&"
import script from "./MyCheckbox.vue?vue&type=script&setup=true&lang=js&"
export * from "./MyCheckbox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MyCheckbox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports